import ArticleListItem from "app/components/ArticleListItem";
import ImmutablePropTypes from "react-immutable-proptypes";
import List from "app/components/UI/List";
import PropTypes from "prop-types";
import React from "react";
import Spinner from "app/components/UI/Spinner";

export const ArticleList = ({ clubId, isLoading, onDeleteArticle, articles }) =>
  isLoading ? (
    <Spinner absolute />
  ) : (
    <List>
      {articles.map(article => (
        <ArticleListItem
          key={article.get("@id")}
          clubId={clubId}
          onDeleteArticle={onDeleteArticle}
          article={article}
          product={article.get("productId")}
        />
      ))}
    </List>
  );

ArticleList.propTypes = {
  isLoading: PropTypes.bool.isRequired,
  onDeleteArticle: PropTypes.func.isRequired,
  articles: ImmutablePropTypes.listOf(ImmutablePropTypes.map).isRequired
};

export default ArticleList;



// WEBPACK FOOTER //
// ./src/app/components/ArticleList/ArticleList.js